/* ============================================================
   KÉNOS — Carrito drawer de marca (AJAX)
   - Intercepta links /cart/{id}:{qty}... y botones [data-kcart-open]
   - Agrega vía /cart/add.js y abre el drawer lateral (no navega a /cart)
   - Stepper de cantidad, quitar, subtotal, barra de envío gratis
   - Descuento por volumen (KENOS2/3/5): % sobre el pedido gatillado por la
     cantidad TOTAL del carrito. Se calcula y se MUESTRA ya aplicado en el
     drawer (precio = ficha), y el código se sincroniza con /discount/CODE
     para que el checkout cobre exactamente lo mismo.
   Montos de la AJAX API vienen en subunidades (x100); se dividen para CLP.
   ============================================================ */
(function () {
  'use strict';
  if (window.KenosCart) return;

  var THRESHOLD = 2500000; // $25.000 en subunidades (x100)

  // Tiers de descuento por volumen — DEBEN coincidir con los códigos de Shopify:
  // KENOS2 (≥2 → 10%), KENOS3 (≥3 → 20%), KENOS5 (≥5 → 35%). Orden descendente:
  // se elige el tier más alto cuyo umbral cumple la cantidad total del carrito.
  var TIERS = [
    { min: 5, pct: 35, code: 'KENOS5' },
    { min: 3, pct: 20, code: 'KENOS3' },
    { min: 2, pct: 10, code: 'KENOS2' }
  ];

  // El descuento por volumen aplica SOLO a las fórmulas individuales. Los packs
  // ya vienen con su precio rebajado, así que NO se les aplica (evita el doble
  // descuento que hacía que el carrito no calzara con la ficha). variant_id de
  // cada fórmula individual:
  var SINGLE_VARIANTS = {
    46478235467975: true, // Ashwagandha 640mg
    46616458461383: true, // NAD+ Resveraforce
    46642836439239: true, // Triple Magnesio
    46642836472007: true  // Melena de León
  };

  var KenosCart = {
    el: null,
    booted: false,
    appliedCode: null, // último código aplicado en esta sesión (evita /discount/ redundantes)

    fmt: function (cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CL');
    },

    // Tier vigente para una cantidad total de unidades (null si <2).
    tierFor: function (count) {
      for (var i = 0; i < TIERS.length; i++) {
        if (count >= TIERS[i].min) return TIERS[i];
      }
      return null;
    },

    // Aplica % de descuento a un monto en subunidades, replicando el cálculo
    // de Shopify (descuento = redondeo(monto × pct); neto = monto − descuento).
    applyPct: function (cents, pct) {
      if (!pct) return cents;
      return cents - Math.round(cents * pct / 100);
    },

    // Sincroniza el código de descuento del checkout con el tier vigente.
    // En segundo plano y sin descargar el HTML de la redirección (redirect:manual),
    // por eso ya no bloquea ni ralentiza el render del carrito.
    syncDiscount: function (code) {
      if (code === this.appliedCode) return; // ya está aplicado este código
      this.appliedCode = code;
      if (!code) return; // sin tier: un código viejo no califica al checkout por su mínimo de cantidad
      // En segundo plano (no se espera → no ralentiza). Redirige a /cart.js para
      // NO descargar el HTML del home (lo pesado del flujo original). La cookie del
      // código se fija igual en la respuesta 302.
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { method: 'GET' }).catch(function () {});
    },

    init: function () {
      if (this.booted) return;
      this.el = document.querySelector('[data-kcart]');
      if (!this.el) return;
      this.booted = true;
      var self = this;

      // Cerrar (scrim, X, "seguir comprando", Esc)
      this.el.querySelectorAll('[data-kcart-close]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); self.close(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('kcart-open')) self.close();
      });

      // Stepper / quitar / agregar upsell (delegado)
      this.el.addEventListener('click', function (e) {
        var add = e.target.closest('[data-kcart-add]');
        if (add) { e.preventDefault(); self.add([{ id: add.getAttribute('data-kcart-add'), quantity: 1 }], ''); return; }
        var inc = e.target.closest('[data-kcart-inc]');
        var dec = e.target.closest('[data-kcart-dec]');
        var rm = e.target.closest('[data-kcart-remove]');
        if (!inc && !dec && !rm) return;
        var row = e.target.closest('[data-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var qty = parseInt(row.getAttribute('data-qty'), 10);
        if (inc) self.change(line, qty + 1);
        else if (dec) self.change(line, Math.max(0, qty - 1));
        else self.change(line, 0);
      });

      // Abrir desde el header / cualquier [data-kcart-open]
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-kcart-open]');
        if (opener) { e.preventDefault(); self.open(); self.refresh(false); return; }
        // Interceptar permalinks de carrito /cart/{id}:{qty}...
        var a = e.target.closest('a[href*="/cart/"]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        if (!/\/cart\/\d+:\d+/.test(href)) return; // /cart (página) no se intercepta
        e.preventDefault();
        self.addFromPermalink(href);
      });

      this.refresh(false); // pinta el badge (y sincroniza el código) al cargar
    },

    parsePermalink: function (href) {
      var items = [];
      var m = href.match(/\/cart\/([^?#]+)/);
      if (m) {
        m[1].split(',').forEach(function (pair) {
          var p = pair.split(':');
          if (p[0]) items.push({ id: p[0].trim(), quantity: parseInt(p[1] || '1', 10) || 1 });
        });
      }
      var dm = href.match(/[?&]discount=([^&]+)/);
      return { items: items, discount: dm ? decodeURIComponent(dm[1]) : '' };
    },

    addFromPermalink: function (href) {
      var p = this.parsePermalink(href);
      return this.add(p.items, p.discount);
    },

    // El parámetro `discount` se ignora a propósito: el tier correcto se deriva
    // de la cantidad TOTAL del carrito en render() (más correcto cuando ya hay
    // items), y allí se sincroniza el código. Así add() = 2 round-trips (rápido).
    add: function (items, discount) {
      var self = this;
      if (!items || !items.length) return;
      this.open();
      this.setLoading(true);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return self.refresh(true); })
        .catch(function () { self.setLoading(false); });
    },

    change: function (line, qty) {
      var self = this;
      this.setLoading(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { self.setLoading(false); });
    },

    refresh: function (openIt) {
      var self = this;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); if (openIt) self.open(); })
        .catch(function () {});
    },

    render: function (cart) {
      var self = this;
      this.setLoading(false);
      var count = cart.item_count || 0;

      // ----- Descuento por volumen (SOLO fórmulas individuales) -----
      // El tier se calcula con las unidades de fórmulas; los packs no cuentan ni
      // se descuentan (ya están rebajados). Así el carrito calza con la ficha.
      var singleUnits = 0;
      (cart.items || []).forEach(function (it) {
        if (SINGLE_VARIANTS[it.variant_id]) singleUnits += it.quantity;
      });
      var tier = this.tierFor(singleUnits);
      var pct = tier ? tier.pct : 0;
      this.syncDiscount(tier ? tier.code : ''); // mantiene el checkout en sincronía
      var fullSub = cart.items_subtotal_price || 0;
      // Subtotal neto: descuenta SOLO las líneas de fórmulas; packs a precio lleno.
      var netSub = 0;
      (cart.items || []).forEach(function (it) {
        netSub += SINGLE_VARIANTS[it.variant_id] ? self.applyPct(it.final_line_price, pct) : it.final_line_price;
      });
      // Ahorro derivado de montos YA redondeados a peso, para que reconcilie.
      var savedPesos = Math.round(fullSub / 100) - Math.round(netSub / 100);

      // Badges (header + título)
      document.querySelectorAll('[data-kcart-badge]').forEach(function (b) {
        b.textContent = count;
        b.classList.toggle('kcart-badge--on', count > 0);
      });
      var countEl = this.el.querySelector('[data-kcart-count]');
      if (countEl) countEl.textContent = count;

      var body = this.el.querySelector('[data-kcart-body]');
      var empty = this.el.querySelector('[data-kcart-empty]');
      var foot = this.el.querySelector('[data-kcart-foot]');

      if (!count) {
        if (body) body.innerHTML = '';
        if (empty) empty.hidden = false;
        if (foot) foot.hidden = true;
        var up0 = this.el.querySelector('[data-kcart-upsell]');
        if (up0) { up0.hidden = true; up0.innerHTML = ''; }
        this.renderShip(0);
        return;
      }
      if (empty) empty.hidden = true;
      if (foot) foot.hidden = false;

      var html = '';
      cart.items.forEach(function (it, i) {
        var line = i + 1;
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        // Precio de línea: descuento de volumen SOLO si es fórmula individual.
        var lineNow = SINGLE_VARIANTS[it.variant_id] ? self.applyPct(it.final_line_price, pct) : it.final_line_price;
        var lineWas = it.original_line_price; // precio lleno (sin oferta de volumen)
        var sale = lineNow < lineWas;
        html += '<div class="kcart-item" data-line="' + line + '" data-qty="' + it.quantity + '">' +
          (img ? '<a class="kcart-item-img" href="' + it.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' : '<span class="kcart-item-img"></span>') +
          '<div class="kcart-item-mid">' +
            '<a class="kcart-item-name" href="' + it.url + '">' + it.product_title + '</a>' +
            '<div class="kcart-item-qty" role="group" aria-label="Cantidad">' +
              '<button type="button" data-kcart-dec aria-label="Quitar uno">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-kcart-inc aria-label="Agregar uno">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="kcart-item-right">' +
            '<div class="kcart-item-price">' + self.fmt(lineNow) +
              (sale ? ' <s>' + self.fmt(lineWas) + '</s>' : '') + '</div>' +
            '<button type="button" class="kcart-item-remove" data-kcart-remove>Quitar</button>' +
          '</div>' +
        '</div>';
      });
      if (body) body.innerHTML = html;

      var sub = this.el.querySelector('[data-kcart-subtotal]');
      if (sub) sub.textContent = this.fmt(netSub);

      // Nota: el descuento ya está EN el precio mostrado (no "se refleja en el pago").
      var note = this.el.querySelector('[data-kcart-note]');
      if (note) {
        if (pct > 0) {
          note.innerHTML = '🌿 Descuento por ' + singleUnits + (singleUnits === 1 ? ' fórmula' : ' fórmulas') + ': <strong>−' + pct + '%</strong> · ahorras $' + savedPesos.toLocaleString('es-CL');
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }

      this.renderShip(netSub);
      this.renderUpsell(cart, netSub);
    },

    // Rail de oportunidades (CRO): packs/fórmulas que el carrito aún no tiene.
    // Resalta «activa envío gratis» cuando agregar la oferta cruza el umbral.
    renderUpsell: function (cart, effectiveTotal) {
      var wrap = this.el.querySelector('[data-kcart-upsell]');
      if (!wrap) return;
      var offers = window.KENOS_OFFERS || [];
      var byId = {};
      offers.forEach(function (o) { byId[o.id] = o; });
      // «Cubierto» = lo que ya está en el carrito + los componentes de los packs en el carrito.
      var covered = {};
      (cart.items || []).forEach(function (it) {
        covered[it.variant_id] = true;
        var o = byId[it.variant_id];
        if (o && o.covers) o.covers.forEach(function (c) { covered[c] = true; });
      });
      var total = (typeof effectiveTotal === 'number') ? effectiveTotal : (cart.total_price || 0);
      var picks = [];
      for (var i = 0; i < offers.length && picks.length < 3; i++) {
        var o = offers[i];
        if (covered[o.id]) continue;
        if (o.kind === 'pack' && o.covers && o.covers.length && o.covers.every(function (c) { return covered[c]; })) continue;
        picks.push(o);
      }
      if (!cart.item_count || !picks.length) { wrap.hidden = true; wrap.innerHTML = ''; return; }
      var self = this;
      var cards = picks.map(function (o) {
        var unlock = total < THRESHOLD && (total + o.price) >= THRESHOLD;
        var ribbon = unlock ? '🔓 Envío gratis' : (o.ribbon || 'Aprovecha');
        var ribClass = unlock ? ' kcart-up-ribbon--ship' : '';
        var was = (o.was && o.was > o.price) ? ' <s>' + self.fmt(o.was) + '</s>' : '';
        return '<div class="kcart-up-card">' +
            '<span class="kcart-up-ribbon' + ribClass + '">' + ribbon + '</span>' +
            '<span class="kcart-up-img">' + (o.img ? '<img src="' + o.img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<div class="kcart-up-tx">' +
              '<div class="kcart-up-name">' + o.title + '</div>' +
              '<div class="kcart-up-bot">' +
                '<span class="kcart-up-price">' + self.fmt(o.price) + was + '</span>' +
                '<button type="button" class="kcart-up-add" data-kcart-add="' + o.id + '" aria-label="Agregar ' + o.title + '">+ Agregar</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');
      var head = total < THRESHOLD ? 'Suma y activa tu envío gratis' : 'Suma a tu ritual';
      wrap.innerHTML = '<p class="kcart-up-head">' + head + '</p><div class="kcart-up-rail">' + cards + '</div>';
      wrap.hidden = false;
    },

    renderShip: function (total) {
      var msg = this.el.querySelector('[data-kcart-ship-msg]');
      var fill = this.el.querySelector('[data-kcart-ship-fill]');
      var wrap = this.el.querySelector('[data-kcart-ship]');
      if (!wrap) return;
      var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
      if (fill) fill.style.width = pct + '%';
      if (total >= THRESHOLD) {
        if (msg) msg.innerHTML = '<strong>¡Tienes envío gratis!</strong> 🌿';
        wrap.classList.add('kcart-ship--done');
      } else {
        var falta = THRESHOLD - total;
        if (msg) msg.innerHTML = 'Te faltan <strong>' + this.fmt(falta) + '</strong> para envío gratis';
        wrap.classList.remove('kcart-ship--done');
      }
    },

    setLoading: function (b) { if (this.el) this.el.classList.toggle('kcart-loading', !!b); },

    open: function () {
      if (!this.el) return;
      this.el.hidden = false;
      document.documentElement.classList.add('kcart-lock');
      var el = this.el;
      requestAnimationFrame(function () { el.classList.add('kcart-open'); });
      var panel = this.el.querySelector('.kcart-panel');
      if (panel) panel.setAttribute('tabindex', '-1'), panel.focus();
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('kcart-open');
      document.documentElement.classList.remove('kcart-lock');
      var el = this.el;
      window.setTimeout(function () { if (!el.classList.contains('kcart-open')) el.hidden = true; }, 340);
    }
  };

  window.KenosCart = KenosCart;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { KenosCart.init(); });
  } else {
    KenosCart.init();
  }
})();
